<template>
  <div class="table">
    <a-modal v-model="visible" title="案件信息" width="1340px" :footer="null" @cancel="close">
      <div class="tableList">
        <a-spin :spinning="loading" class="spin-content" tip="正在加载。。。" :delay="100">
          <div class="table">
            <table>
              <thead>
                <td width="80">序号</td>
                <td width="90">被告</td>
                <td width="170">证件号码</td>
                <td width="80">所属案件</td>
                <td width='130'>当前进度</td>
                <td width="190">原告</td>
                <td width="170">文书类型</td>
                <td width="240">案号</td>
                <td width="120">主张债权（本金）</td>
              </thead>
              <tbody>
                <tr v-for='(i, index) in list' :key='index'>
                  <td width="80">{{ index + 1 + (10 * (pagination.page - 1)) }}</td>
                  <td width="90"><span class="curpoter" @click='dbclick(i)'>
                      <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                    </span></td>
                  <!-- <td>{{i.realname}}</td> -->
                  <td width="170">{{ i.chinaid }}</td>
                  <td width="80">
                    <div class="p" v-for="j in i.cause" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }"> 案件{{
                      j.sort }}
                    </div>
                  </td>
                  <td width='130'>
                    <div class="p" v-for="j in i.cause" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }">
                      {{ j.step.length ? j.step[0].title : '/' }}
                    </div>
                  </td>
                  <td width="190">
                    <div class="p" v-for="j in i.cause" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }">
                      <Normap :tit='j.accuser.title' style="width:100%;">{{ j.accuser.title }}</Normap>
                    </div>
                  </td>

                  <td width="170">
                    <div v-for="j in i.cause" class="p" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }">
                      <div v-for="k in j.step_cpws" style="padding:4px 0;">
                        {{ liteKey[k.step] + '-' + book[k.type] }}
                      </div>
                    </div>
                  </td>
                  <td width="240">
                    <div class="p" v-for="j in i.cause" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }">
                      <Normap :tit='j.no || "/"'></Normap>
                    </div>
                  </td>
                  <td width="120">
                    <div class="p" v-for="j in i.cause" :style="{ 'height': j.step_cpws.length * 30 + 20 + 'px' }">{{
                      j.capital |
                      showYuan}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </a-spin>
      </div>
      <div style="text-align:center;padding-top:20px;" v-if='count > 10'>
        <a-pagination v-model="pagination.page" show-quick-jumper :total="count" show-less-items @change='turn' />
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  listbycourt
} from "@/server/statis"
import liteKey from '@/page/ly/liteKey.json'
export default {
  props: {
    court: String,
    form: Object
  },
  data() {
    return {
      book: {
        1: '判决书',
        2: '调解书',
        3: '其他裁定',
        5: '撤诉裁定',
        4: '撤诉申请'
      },
      liteKey,
      visible: false,
      list: [],
      count: 0,
      pagination: {
        limit: 10,
        page: 1,
      },
      loading: true,
    }
  },
  methods: {
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({
          "name": "lydetails",
          params: {
            "id": record.cause[0].debtor_id
          }
        });
        window.open(routeUrl.href, '_blank');
      } else {
        this.$message.error({
          content: '暂无权限',
          key: 'updatable'
        });
      }
    },
    reset() {
      this.pagination.page = 1;
      this.getList()
    },
    turn(val) {
      this.pagination.page = val
      this.getList()
    },
    close() {
      this.list = []
      this.page = 1;
    },
    getList() {
      this.loading = true;
      let pagination = JSON.parse(JSON.stringify(this.pagination))
      listbycourt(Object.assign(pagination, this.form)).then(e => {
        this.count = e.count
        this.list = e.list
        this.loading = false;
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tablebox {
  min-height: 500px;
}

.tableList {
  width: 100%;
  min-height: 500px;

  .table {
    thead {
      display: flex;

      td {
        display: flex;
        align-items: center;
        padding-left: 0;

        &:nth-child(1) {
          // padding-left: 20px;
        }
      }
    }

    tbody {
      tr {
        display: flex;
      }

      tr:nth-last-child(1) {
        border-bottom: 1px solid #ebebeb;
      }

      td {
        vertical-align: middle;
        padding: 6px 0;
        height: auto;
        display: flex;
        min-height: 60px;
        flex-direction: column;
        justify-content: center;

        &:nth-child(1) {
          // padding-left: 20px;
        }

        .p {
          padding: 10px 10px 10px 0;
          margin: 0;
          align-items: flex-start;
          border-bottom: 1px solid #ebebeb;
          display: flex;
          flex-direction: column;
          justify-content: center;

          &:nth-child(1) {
            // padding-left: 20px;
          }

          .p {
            padding: 10px 10px 10px 0;
            margin: 0;
            align-items: flex-start;
            border-bottom: 1px solid #ebebeb;
            display: flex;
            flex-direction: column;
            justify-content: center;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}
</style>